import React from 'react';
import { BsThreeDots } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, Icon, IconButton, Text } from '@chakra-ui/react';

import { CypressIds } from '../../../../constants/cypressIds';
import { showModal } from '../../../../redux/modules/modal';
import { agentCertificateCreator } from '../../../../redux/reducer';

import EditAgencyModal from './EditAgencyModal';

export const getAgencyColumns = insuranceRequestId => ([
  {
    Header: 'Selected',
    disableSortBy: true,
    Cell: ({ cell: { value }, row: { original } }) => {
      const agencyId = useSelector(agentCertificateCreator.selectAgencyId);

      return (
        <Checkbox
          borderColor="greyScale.300"
          data-cy={CypressIds.certAgentAgencyCheckbox(original.agencyId)}
          isChecked={original.agencyId === agencyId}
          mb={0}
        />
      );
    }
  },
  {
    Header: 'Company Name',
    accessor: 'agency.name'
  },
  {
    Header: 'Agent License/Broker #',
    accessor: 'license'
  },
  {
    Header: 'Company Address',
    disableSortBy: true,
    Cell: ({ cell: { value }, row: { original } }) => {
      const { agency: { address1, address2, city, state, zip } } = original;

      return (
        <Text>{`${address1}${address2 ? ` ${address2}` : ''}, ${city}, ${state} ${zip}`}</Text>
      );
    }
  },
  {
    Header: ' ',
    disableSortBy: true,
    Cell: ({ cell: { value }, row: { original } }) => {
      const { agency: { name }, agencyId, license } = original;
      const dispatch = useDispatch();

      return (
        <IconButton
          aria-label={`edit_agency_details_${agencyId}`}
          icon={<Icon as={BsThreeDots} boxSize="20px" px={0} />}
          size="xs"
          variant="ghost"
          onClick={() => dispatch(showModal(() => (
            <EditAgencyModal
              agencyId={agencyId}
              defaultLicense={license}
              defaultName={name}
              insuranceRequestId={insuranceRequestId}
            />
          ), {
            title: 'Edit Company/Agency',
            size: '3xl'
          }))}
        />
      );
    }
  }
]);
